import React, { Fragment } from 'react';

import dayjs from 'dayjs';
import getSymbolFromCurrency from 'currency-symbol-map';
import { arrayOf, func, shape, string } from 'prop-types';

import { Button, ModalBox } from '../../../../../../../common';
import { LeftArrowIcon } from '../../../../../../../theme/images';

const InvoicePauseConfirm = ({
  adjustmentData,
  returnTotalAmount,
  onApply,
  onBackClick,
  selectedMonthYear,
  formatNumber,
  currencySymbol,
}) => {
  const { totalNewBudget } = returnTotalAmount();
  const renderResponsiveView = () => {
    return (
      <div className="d-md-none d-block">
        {adjustmentData &&
          adjustmentData.length > 0 &&
          adjustmentData.map((item) => {
            const textClass =
              item && item.is_sent_for_pause
                ? 'normal-text text-bold'
                : 'gray-normal-text';
            return (
              <Fragment key={item.id}>
                <div className="row">
                  <div className="col-12 text-left mb-2">
                    <div className="label">Marketplace</div>
                    <div className={textClass}>{item.marketplace}</div>
                  </div>

                  <div className="col-6 text-left">
                    <div className="label">Invoice Amount</div>
                    <div className={textClass}>
                      {formatNumber(
                        item.new_budget,
                        getSymbolFromCurrency(
                          item?.local_currency ? item?.local_currency : 'USD',
                        ),
                      )}
                    </div>
                  </div>
                  <div className="col-6 text-left">
                    <div className="label">Pause Invoice</div>
                    <div className={textClass}>
                      {item.is_sent_for_pause ? 'Yes' : 'No'}
                    </div>
                  </div>
                </div>
                <div className=" straight-line horizontal-line mt-2 mb-2 " />
              </Fragment>
            );
          })}

        <div className="row">
          <div className="col-12 text-left mb-2">
            <div className="label text-bold"> </div>
            <div className="normal-text text-bold">Total invoice</div>
          </div>

          <div className="col-6 text-left">
            <div className="label">Invoice Amount</div>
            <div className="normal-text text-bold">
              {formatNumber(totalNewBudget, `${currencySymbol || '$'}`)}
            </div>
          </div>
          <div className=" straight-line horizontal-line mt-2 mb-2 " />
          <div className="col-12 text-left normal-text">
            The change will apply to
            <b>{dayjs(selectedMonthYear?.value).format('MMMM')} only.</b>
          </div>
        </div>
      </div>
    );
  };

  const renderDesktopView = () => {
    return (
      <div className="d-md-block d-none">
        <div className="row">
          <div className="col-4 pr-2 text-left">
            <div className="label">Marketplace</div>
          </div>
          <div className="col-4 px-1 text-left">
            <div className="label">Invoice Amount</div>
          </div>
          <div className="col-4 pl-1 text-left">
            <div className="label">Pause Invoice</div>
          </div>
        </div>
        <div className=" straight-line horizontal-line pt-1 mb-2 " />

        {adjustmentData &&
          adjustmentData.length > 0 &&
          adjustmentData.map((item) => {
            const textClass =
              item && item.is_sent_for_pause
                ? 'normal-text text-bold'
                : 'gray-normal-text';
            return (
              <div key={item.id} className="row mt-1">
                <div className="col-4 pr-2 text-left">
                  <div className={textClass}>{item.marketplace}</div>
                </div>
                <div className="col-4 px-1 text-left">
                  <div className={textClass}>
                    {formatNumber(
                      item.new_budget,
                      getSymbolFromCurrency(
                        item?.local_currency ? item?.local_currency : 'USD',
                      ),
                    )}
                  </div>
                </div>
                <div className="col-4 pl-1 text-left">
                  <div className={textClass}>
                    {item.is_sent_for_pause ? 'Yes' : 'No'}
                  </div>
                </div>
              </div>
            );
          })}

        <div className=" straight-line horizontal-line pt-1 mb-2 " />
        <div className="row">
          <div className="col-4 pr-2 text-left">
            <div className="normal-text text-bold">Total invoice</div>
          </div>
          <div className="col-4 px-1 text-left">
            <div className="normal-text text-bold">
              {formatNumber(totalNewBudget, `${currencySymbol || '$'}`)}
            </div>
          </div>
          <div className="col-4 pl-1 text-left" />
        </div>
        <div className=" straight-line horizontal-line mt-2 mb-2 " />
        <p className="normal-text">
          The change will apply to{' '}
          <b>{dayjs(selectedMonthYear?.value).format('MMMM')} only.</b>
        </p>
      </div>
    );
  };

  return (
    <>
      <ModalBox>
        <div className="modal-body pb-0 ">
          <h4 className="mb-3">
            <img
              role="presentation"
              onClick={onBackClick}
              className="modal-back-arrow"
              src={LeftArrowIcon}
              alt="back-arrow"
            />
            Confirm Pause
          </h4>
          <div className="body-content">
            <div className=" straight-line horizontal-line pt-1 mb-2 " />
            {renderDesktopView()}
            {renderResponsiveView()}
          </div>
        </div>
        <div className="modal-footer">
          <Button
            onClick={onApply}
            type="button"
            className="btn-primary on-boarding   w-100"
          >
            Confirm
          </Button>
        </div>
      </ModalBox>
    </>
  );
};

export default InvoicePauseConfirm;

InvoicePauseConfirm.defaultProps = {
  adjustmentData: [],
  onApply: () => {},
  onBackClick: () => {},
  returnTotalAmount: () => {},
  selectedMonthYear: {},
};

InvoicePauseConfirm.propTypes = {
  adjustmentData: arrayOf(Array),
  currencySymbol: string.isRequired,
  onApply: func,
  onBackClick: func,
  returnTotalAmount: func,
  selectedMonthYear: shape({}),
  formatNumber: func.isRequired,
};
